import { action, createRequestTypes } from './base';

export const addressActionTypes = {
  GET_ADDRESSES: createRequestTypes('GET_ADDRESSES'),
  CREATE_ADDRESS: createRequestTypes('CREATE_ADDRESS'),
  UPDATE_ADDRESS: createRequestTypes('UPDATE_ADDRESS'),
};

/**
 * TenantActions class
 */
class AddressActions {
  /**
   * @param page
   * @param entityId
   * @param entityType
   * @param addressId
   */
  getAddresses = (page, entityId, entityType, addressId) => action(addressActionTypes.GET_ADDRESSES.REQUEST, {
    page,
    entityId,
    entityType,
    addressId,
  });

  /**
   * @param getAddressesLoading
   * @param getTenantsLoading
   * @return {{type: *}}
   */
  getAddressesLoading = (getAddressesLoading) => action(addressActionTypes.GET_ADDRESSES.LOADING, {
    getAddressesLoading,
  });

  /**
   * @param addresses
   * @param type
   * @param tenants
   * @return {{type: *}}
   */
  getAddressesSuccess = (addresses) => action(addressActionTypes.GET_ADDRESSES.SUCCESS, {
    addresses,
  });

  /**
   *
   * @type {{type: *}}
   */
  createAddress = (payload, callback) => action(addressActionTypes.CREATE_ADDRESS.REQUEST, {
    payload,
    callback,
  });

  /**
   * @param createAddressLoading
   * @param createTenantLoading
   * @return {{type: *}}
   */
  createAddressLoading = (createAddressLoading) => action(addressActionTypes.CREATE_ADDRESS.LOADING, {
    createAddressLoading,
  });

  /**
   *
   * @type {{type: *}}
   */
   updateAddress = (payload, callback) => action(addressActionTypes.UPDATE_ADDRESS.REQUEST, {
     payload,
     callback,
   });

   /**
    * @param createAddressLoading
    * @param updateAddressLoading
    * @param createTenantLoading
    * @return {{type: *}}
    */
   updateAddressLoading = (updateAddressLoading) => action(
     addressActionTypes.UPDATE_ADDRESS.LOADING, {
       updateAddressLoading,
     },
   );
}

export default new AddressActions();
